<template>
    <div class="fixed-sidebar" :class="{ active: showBackTop }"
        style="position: fixed; right: 10px; top: 50%; transform: translateY(-50%); z-index: 999; display: flex; flex-direction: column;">
        <div class="sldebar-section"
            style="display: flex; align-items: center; flex-direction: column; padding: 10px; border-radius: 16px; background: #FFF; border: 1px solid #ededed;">
            <div class="sidebar-item kf-consult-btn" @pointerdown="preloadCustomerService" @click="openCustomerService" data-buriedname="sideBar_kf" data-buriedvalue="sideBar_kf"
                style="position: relative; display: flex; align-items: center; flex-direction: column; margin-bottom: 19px; cursor: pointer; font-size: 12px;">
                <div class="sidebar-icon"
                    style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; position: relative;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M10.6041 30.6577C10.4293 30.6577 10.2568 30.6171 10.1003 30.539C9.91293 30.4454 9.7553 30.3014 9.64513 30.1232C9.53496 29.945 9.47659 29.7397 9.47657 29.5301V25.2843C4.50902 23.1606 1.34229 18.7935 1.34229 13.9707C1.34229 7.00742 7.91742 1.34235 15.9999 1.34235C24.0824 1.34235 30.6576 7.00742 30.6576 13.9707C30.6576 20.8238 24.2889 26.4193 16.3826 26.5946L11.2818 30.4311C11.0865 30.5782 10.8486 30.6577 10.6041 30.6577ZM16 3.59738C9.16111 3.59738 3.59732 8.25085 3.59732 13.9707C3.59732 18.0739 6.50146 21.7997 10.9956 23.4629C11.4376 23.6264 11.7316 24.0484 11.7316 24.5202V27.271L15.3223 24.5703C15.5176 24.4233 15.7555 24.3438 16 24.3437C22.8388 24.3437 28.4026 19.6903 28.4026 13.9707C28.4026 8.25085 22.8388 3.59738 15.9999 3.59738H16Z"
                            fill="#333333" />
                        <path
                            d="M15.2908 21.354C11.1991 21.354 7.86231 18.9014 6.36426 14.7935L9.01236 13.8278C10.103 16.8195 12.3916 18.5353 15.2908 18.5353V21.354Z"
                            fill="#FB4643" />
                    </svg>
                </div>
                <p style="white-space: nowrap;">在线咨询</p>
            </div>

            <div class="sidebar-item" @mouseenter="showTel = true" @mouseleave="showTel = false"
                style="position: relative; display: flex; align-items: center; flex-direction: column; margin-bottom: 19px; cursor: pointer; font-size: 12px;">
                <div class="sidebar-icon"
                    style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; position: relative;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <g clip-path="url(#clip0_833_5519)">
                            <path
                                d="M26.3655 18.1031C25.2114 17.7028 24.0396 17.4931 22.9761 17.4931C22.1849 17.4931 21.4667 17.6062 20.8427 17.8291C19.7205 18.2294 18.9639 18.9641 18.6802 19.9034C18.6127 20.0012 18.4555 20.1594 18.2639 20.22C18.2299 20.22 18.1686 20.2097 18.0402 20.1312C16.8649 19.3606 15.7214 18.4778 14.6411 17.5062C13.6774 16.6609 12.7392 15.7059 11.8739 14.6947C11.6617 14.3306 11.6983 14.1734 11.7402 14.1272C12.5533 13.8144 13.1517 13.1956 13.5192 12.2831C14.1671 10.6053 13.8674 8.1978 12.7164 5.84687C11.2189 2.77812 8.78393 0.716553 6.65549 0.716553C6.29893 0.716553 5.95487 0.775615 5.60362 0.899365L5.42987 0.984365C5.37455 1.00874 5.32174 1.03312 5.28705 1.05655C3.88268 1.48905 2.71674 2.23249 1.82112 3.26718C-2.26763 8.04874 0.746116 17.3662 8.68268 24.4769C13.4358 28.7387 19.0358 31.2825 23.663 31.2837C24.893 31.2837 26.0333 31.1009 27.0517 30.7381C28.3271 30.2812 29.3711 29.5556 30.1502 28.5853C30.9208 27.7025 31.4664 26.5575 31.8717 24.9631C31.8911 24.8447 31.9521 24.5322 31.9533 24.5269C32.3642 22.0728 30.0139 19.3719 26.3655 18.1031ZM23.6974 29.1141C19.6236 29.1141 14.4071 26.7053 10.0836 22.8281C3.27393 16.7134 0.22174 8.39593 3.41674 4.66562C4.07299 3.92437 4.9333 3.39187 5.98174 3.07905C6.0608 3.05062 6.14143 3.01999 6.1858 2.99405L6.29893 2.93624L6.31705 2.91812C6.41612 2.88218 6.52674 2.86405 6.6458 2.86405C7.72674 2.86405 9.6233 4.37468 10.8033 6.81437C11.668 8.58999 11.9555 10.4328 11.5367 11.5122C11.3521 11.9922 11.1011 12.0834 11.0264 12.1106C11.0167 12.1131 10.0567 12.4644 9.69924 13.4747C9.43487 14.2094 9.55393 15.0241 10.0808 15.935C10.1052 15.9594 10.1355 15.9994 10.1858 16.0662C11.1014 17.1406 12.1211 18.1856 13.2155 19.17C14.3954 20.2387 15.6566 21.214 16.9877 22.0872C17.0314 22.1128 17.0849 22.145 17.1336 22.1566C17.4771 22.3381 17.8396 22.4294 18.2099 22.4294C18.4749 22.4294 18.7399 22.3831 18.9974 22.2903C20.0286 21.9222 20.5427 20.9728 20.5555 20.9469C20.6167 20.8528 20.6521 20.7409 20.683 20.6419C20.7674 20.2391 21.2446 20.0141 21.5227 19.9162C21.9214 19.7734 22.4021 19.7 22.9524 19.7C23.7752 19.7 24.7011 19.8647 25.6283 20.1722C28.4739 21.1631 30.0214 23.115 29.8777 24.08L29.8411 24.2962L30.0289 24.3322L29.8152 24.4428C29.6042 25.5031 29.1396 26.5156 28.5399 27.2209C27.9864 27.8784 27.2517 28.3725 26.3561 28.6931C25.5733 28.9725 24.6786 29.1141 23.6974 29.1141Z"
                                fill="#333333" />
                            <path
                                d="M18.0306 8.62375L18.1909 8.61343C18.3896 8.5825 18.5871 8.56718 18.7821 8.56718C20.7121 8.56718 22.3884 10.0303 22.6809 11.9706C22.764 12.5084 23.209 12.8984 23.7406 12.8984C23.7915 12.8984 23.8434 12.8959 23.8878 12.8881C23.9637 12.8881 24.0324 12.8637 24.0918 12.8419C24.5943 12.6631 24.8806 12.1572 24.7893 11.6156C24.3531 8.62406 21.7868 6.36812 18.8206 6.36812C18.5028 6.36812 18.1818 6.39375 17.8653 6.44406C17.2812 6.53812 16.8796 7.09906 16.9696 7.69343C17.0528 8.2325 17.4984 8.62375 18.0306 8.62375ZM18.394 3.26937C18.4487 3.26937 18.5046 3.26562 18.5593 3.25656C18.9834 3.19093 19.415 3.1575 19.8415 3.1575C21.6025 3.1575 23.279 3.71593 24.6887 4.77093C26.4509 6.08468 27.6065 8.03281 27.9428 10.255C28.0237 10.7866 28.4775 11.1866 28.9978 11.1866C29.05 11.1866 29.1028 11.1828 29.1484 11.175C29.2256 11.175 29.2943 11.1506 29.3543 11.1287C29.8471 10.9512 30.1443 10.4209 30.0465 9.90375C29.6515 7.11156 28.1962 4.65906 25.9515 2.99656C24.1771 1.66218 22.0746 0.957184 19.8715 0.957184C19.3306 0.957184 18.779 1.00093 18.2328 1.08718C17.6537 1.18375 17.2528 1.74343 17.339 2.33781C17.42 2.86937 17.8737 3.26937 18.394 3.26937Z"
                                fill="#FB4643" />
                        </g>
                        <defs>
                            <clipPath id="clip0_833_5519">
                                <rect width="32" height="32" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <p style="white-space: nowrap;">电话咨询</p>
                <div class="sidebar-content tel-content" :class="{ active: showTel }"
                    style="position: absolute; right: 65px; background-color: #fff; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); padding: 10px; opacity: 0; visibility: hidden; transform: translateX(10px); transition: all 0.3s ease; white-space: nowrap; border-radius: 16px; min-width: 152px; height: 80px; line-height: 16px; text-align: center;">
                    <div class="tel-title" style="font-size: 12px; color: #666; margin-bottom: 5px;">电话咨询</div>
                    <div class="tel-number" style="font-size: 16px; font-weight: 500; color: #333; margin-bottom: 5px;">
                        <a href="tel:400-808-1648" style="text-decoration: none; color: #333;">400-808-1648</a>
                    </div>
                    <div class="tel-time" style="font-size: 12px; color: #999;">工作时间 9:00 - 21:00</div>
                </div>
            </div>

            <div class="sidebar-item"
                style="position: relative; display: flex; align-items: center; flex-direction: column; margin-bottom: 19px; cursor: pointer; font-size: 12px;">
                <a href="/help/classroom" class="sidebar-icon"
                    style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; position: relative;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M8.32354 13.4399L14.5596 19.676C14.9159 20.0322 15.4502 20.3885 16.1631 20.3885C16.6974 20.3885 17.2322 20.2104 17.7665 19.676L23.8241 13.6184C24.3585 13.084 24.3585 12.3712 23.8241 11.8364C23.646 11.6583 23.2898 11.4802 22.9332 11.4802C22.5766 11.4802 22.2207 11.6583 22.0422 11.8364L17.2318 16.4687V3.10628C17.2318 2.39378 16.6974 1.85907 15.9846 1.85907C15.2718 1.85907 14.7374 2.39344 14.7374 3.10628V16.4687L10.1051 11.6583C9.74887 11.4802 9.39262 11.3021 9.2145 11.3021C8.85825 11.3021 8.502 11.4802 8.32354 11.6583C7.96729 11.8364 7.96729 12.1927 7.96729 12.5493C7.96729 12.9059 7.96729 13.0837 8.32354 13.4399Z"
                            fill="#FB4643" />
                        <path
                            d="M25.5439 4.74716C24.7939 4.74716 24.2311 5.30966 24.2311 6.06002C24.2311 6.81038 24.7936 7.37145 25.5439 7.37145C27.0439 7.37145 28.3571 8.6843 28.3571 10.1847V25.1882C28.3571 26.6882 27.0443 28.0014 25.5439 28.0014H6.41427C4.91427 28.0014 3.60106 26.6886 3.60106 25.1882V10.1861C3.60106 8.68609 4.91391 7.37288 6.41427 7.37288C7.16427 7.37288 7.72713 6.81038 7.72713 6.06002C7.72713 5.30966 7.16463 4.74716 6.41427 4.74716C3.41356 4.74716 0.975342 7.18538 0.975342 10.1861V25.1897C0.975342 28.1897 3.41356 30.6286 6.41427 30.6286H25.5439C28.5439 30.6286 30.9828 28.1904 30.9828 25.1897V10.1861C30.9828 7.18609 28.5446 4.74716 25.5439 4.74716Z"
                            fill="#333333" />
                    </svg>
                </a>
                <p style="white-space: nowrap;">如何下载</p>
            </div>

            <div class="sidebar-item" @mouseenter="showFollowUs = true" @mouseleave="showFollowUs = false"
                style="position: relative; display: flex; align-items: center; flex-direction: column; margin-bottom: 6px; cursor: pointer; font-size: 12px;">
                <div class="sidebar-icon"
                    style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; position: relative;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M21.4765 2.83429C25.5953 2.83429 29.1496 5.79429 30.1942 9.93943C30.3965 10.7417 30.4993 11.5714 30.4993 12.4149C30.4993 14.3029 30.0022 15.9463 29.0913 17.6011C28.9422 17.8723 28.6915 18.0731 28.3943 18.1593C28.0972 18.2456 27.7779 18.2103 27.5068 18.0611C27.2356 17.912 27.0349 17.6613 26.9486 17.3641C26.8623 17.067 26.8976 16.7477 27.0468 16.4766C27.7816 15.1417 28.1668 13.8709 28.1668 12.4149C28.1668 11.7634 28.0868 11.1257 27.9313 10.5097C27.1416 7.37372 24.4936 5.168 21.4765 5.168C19.7451 5.168 18.0971 5.88686 16.8411 7.19315C16.7323 7.30618 16.6018 7.3961 16.4575 7.45752C16.3132 7.51894 16.1579 7.5506 16.0011 7.5506C15.8442 7.5506 15.689 7.51894 15.5446 7.45752C15.4003 7.3961 15.2698 7.30618 15.1611 7.19315C13.9153 5.904 12.2296 5.168 10.5233 5.168C6.85477 5.168 3.83306 8.40229 3.83306 12.4149C3.83306 14.384 4.38849 15.6869 5.81706 17.8891C6.95192 19.6503 8.92906 21.7474 11.4056 23.9589C12.1045 24.5815 12.8155 25.1904 13.5382 25.7851L14.2056 26.3291L14.7313 26.7463L15.2353 27.1383L15.3131 27.1966C15.5107 27.3526 15.7555 27.4366 16.0072 27.435C16.259 27.4333 16.5027 27.346 16.6982 27.1874L17.1896 26.8046L17.7142 26.3874L18.3256 25.8891C18.5645 25.6924 18.8717 25.5987 19.1797 25.6284C19.4877 25.6582 19.7712 25.8092 19.9679 26.048C20.1646 26.2869 20.2584 26.5941 20.2286 26.9021C20.1988 27.21 20.0479 27.4936 19.8091 27.6903L19.1748 28.2069L18.4022 28.8206L18.1188 29.0389C17.5135 29.511 16.7676 29.7669 15.9999 29.7657C15.2986 29.767 14.6137 29.5532 14.0376 29.1532L13.8171 28.9897L13.2925 28.584L12.5953 28.0263C11.6622 27.2732 10.7476 26.4973 9.85249 25.6994C7.23077 23.36 5.13135 21.1314 3.8582 19.1566C2.20449 16.608 1.50049 14.9531 1.50049 12.4149C1.50049 7.14858 5.52792 2.83429 10.5233 2.83429C12.4662 2.83429 14.3702 3.52 15.9188 4.74172L15.9976 4.80458L16.0822 4.736C17.5475 3.56246 19.3544 2.89667 21.2308 2.83886L21.4765 2.83429Z"
                            fill="#333333" />
                        <path
                            d="M27.3325 21.5005C27.6345 21.4987 27.9255 21.6143 28.1441 21.8227C28.3626 22.0312 28.4917 22.3164 28.5042 22.6182C28.5166 22.92 28.4114 23.2148 28.2108 23.4406C28.0101 23.6664 27.7297 23.8055 27.4285 23.8285L27.3325 23.832H20.6662C20.3604 23.8396 20.0639 23.7267 19.8406 23.5177C19.6172 23.3087 19.485 23.0202 19.4724 22.7146C19.4598 22.409 19.5679 22.1107 19.7732 21.884C19.9786 21.6573 20.2648 21.5204 20.5702 21.5028L20.6662 21.4994H27.3325V21.5005Z"
                            fill="#FB4643" />
                        <path
                            d="M24.0011 18.1657C24.6091 18.1657 25.1142 18.6309 25.1645 19.2354L25.1679 19.3314V25.9989C25.1756 26.3046 25.0627 26.6012 24.8537 26.8245C24.6446 27.0478 24.3562 27.18 24.0506 27.1926C23.745 27.2052 23.4466 27.0972 23.2199 26.8918C22.9933 26.6865 22.8564 26.4002 22.8388 26.0949L22.8342 25.9989V19.3314C22.8342 18.688 23.3577 18.1657 24.0011 18.1657Z"
                            fill="#FB4643" />
                    </svg>
                </div>
                <p style="white-space: nowrap;">关注我们</p>
                <div class="sidebar-content followus-content" :class="{ active: showFollowUs }"
                    style="position: absolute; right: 65px; background-color: #fff; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); padding: 15px; opacity: 0; visibility: hidden; transform: translateX(10px); transition: all 0.3s ease; white-space: nowrap; border-radius: 16px; width: 240px;">
                    <div class="qrcode-container" style="display: flex; justify-content: space-between; gap: 10px;">
                        <div class="qrcode-item" style="text-align: center; position: relative;">
                            <div class="qrcode-placeholder"
                                style="position: absolute; top: 0; left: 0; width: 100px; height: 100px; background-color: transparent; margin: 0 auto;">
                            </div>
                            <img :src="getSidebarImagePath('official-account.png')" alt="欧那{{currentLangName}}公众号"
                                @load="onImageLoaded('official-account.png')"
                                :style="{ opacity: loadedImages['official-account.png'] ? 1 : 0, width: '100px', height: '100px', objectFit: 'cover', marginBottom: '5px', transition: 'opacity 0.3s' }" />
                            <p style="font-size: 12px; color: #666;">欧那{{ currentLangName }}公众号</p>
                        </div>
                        <div class="qrcode-item" style="text-align: center; position: relative;">
                            <div class="qrcode-placeholder"
                                style="position: absolute; top: 0; left: 0; width: 100px; height: 100px; background-color: transparent; margin: 0 auto;">
                            </div>
                            <!-- 葡语和西语显示小红书 -->
                            <img v-if="currentLang === 'pt' || currentLang === 'es'" :src="xiaohongshuQrCode" alt="欧那{{currentLangName}}小红书"
                                @load="onImageLoaded('xiaohongshu.png')"
                                :style="{ opacity: loadedImages['xiaohongshu.png'] ? 1 : 0, width: '100px', height: '100px', objectFit: 'cover', marginBottom: '5px', transition: 'opacity 0.3s' }" />
                            <!-- 其他语言显示视频号 -->
                            <img v-else :src="getSidebarImagePath('video-account.png')" alt="欧那{{currentLangName}}视频号"
                                @load="onImageLoaded('video-account.png')"
                                :style="{ opacity: loadedImages['video-account.png'] ? 1 : 0, width: '100px', height: '100px', objectFit: 'cover', marginBottom: '5px', transition: 'opacity 0.3s' }" />
                            <p style="font-size: 12px; color: #666;">{{ (currentLang === 'pt' || currentLang === 'es') ? '欧那' + currentLangName + '小红书' : '欧那' + currentLangName + '视频号' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-item back-top" :class="{ show: showBackTop && scrollY > windowHeight }"
            @click="scrollToTop">
            <div class="sidebar-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path
                        d="M25.0953 15.3895L16.8094 7.09781C16.6057 6.89318 16.3397 6.79494 16.0746 6.79696C16.0388 6.79389 16.0081 6.77649 15.9723 6.77649C15.8229 6.77649 15.6837 6.81125 15.5558 6.86859C15.4269 6.91771 15.3041 6.99241 15.1997 7.09675L6.90681 15.3831C6.50667 15.7822 6.50568 16.4299 6.90576 16.8301C7.10527 17.0306 7.36727 17.1309 7.63029 17.1309C7.89226 17.1309 8.1532 17.0306 8.35377 16.8321L14.949 10.2394V28.266C14.949 28.8319 15.4074 29.2893 15.9723 29.2893C16.5372 29.2893 16.9957 28.8319 16.9957 28.266V10.1892L23.6443 16.8324C23.8438 17.0329 24.1078 17.1342 24.3698 17.1342C24.6318 17.1342 24.8917 17.035 25.0912 16.8365C25.4933 16.4384 25.4944 15.7896 25.0953 15.3895Z"
                        fill="#333333" />
                    <path
                        d="M27.2563 4.75743H4.74355C4.17866 4.75743 3.72021 4.29899 3.72021 3.73409C3.72021 3.16919 4.17866 2.71082 4.74355 2.71082H27.2563C27.8222 2.71082 28.2796 3.16926 28.2796 3.73415C28.2796 4.29905 27.8221 4.75743 27.2563 4.75743Z"
                        fill="#FB4643" />
                </svg>
            </div>
            <p style="white-space: nowrap;">回到顶部</p>
        </div>
    </div>
</template>

<script>
import { useSiteConfigStore } from '@/stores/SiteConfig'
import { getImagePath, getImagePrefix } from '@/utils/ImageHelper'
import { openCustomerService, preloadCustomerService } from '@/utils/CustomerService'

export default {
    name: 'SideBar',
    data() {
        return {
            showConsult: false,
            showTel: false,
            showFollowUs: false,
            showBackTop: true,
            scrollY: 0,
            windowHeight: 0,
            siteConfig: useSiteConfigStore(),
            // 图片加载状态跟踪
            loadedImages: {
                'consult-ic.png': false,
                'tel-ic.png': false,
                'down-ic.png': false,
                'add-ic.png': false,
                'official-account.png': false,
                'video-account.png': false,
                'xiaohongshu.png': false
            }
        }
    },
    computed: {
        currentLang() {
            try {
                // 优先使用 Pinia store 中的站点配置
                if (this.siteConfig && this.siteConfig.profile) {
                    return this.siteConfig.profile;
                }
                
                // 其次使用全局变量
                if (typeof __SITE_PROFILE__ !== 'undefined') {
                    return __SITE_PROFILE__ || 'fr';
                }

                // 再次尝试从 window 配置获取
                if (typeof window !== 'undefined' && window.__INITIAL_SITE_CONFIG__ && window.__INITIAL_SITE_CONFIG__.profile) {
                    return window.__INITIAL_SITE_CONFIG__.profile;
                }

                // 最后尝试从 $site 获取
                if (this.$site && this.$site.profile) {
                    return this.$site.profile;
                }
            } catch (e) {
                // 静默处理，使用默认语言
            }
            return 'fr';
        },
        currentLangName() {
            // 优先使用站点配置中的语言名称
            return this.siteConfig.languageName || '法语'
        },
        xiaohongshuQrCode() {
            const prefix = getImagePrefix();
            // 葡语版本使用 /images/pt/home/hongshu.png
            if (this.currentLang === 'pt') {
                return `${prefix}/pt/home/hongshu.png`;
            }
            // 西语版本使用 /images/es/home/xiaohongshu.png
            if (this.currentLang === 'es') {
                return `${prefix}/es/home/jump.png`;
            }
            return '';
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        // 预加载所有侧边栏图标
        this.preloadSidebarImages();

        // 确保侧边栏内容初始状态是隐藏的
        this.showConsult = false;
        this.showTel = false;
        this.showFollowUs = false;
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        getImagePath,
        openCustomerService,
        preloadCustomerService,
        // 直接获取sidebar图片路径，避免语言前缀重复
        getSidebarImagePath(filename) {
            const prefix = getImagePrefix();
            const lang = this.currentLang;
            const path = `${prefix}/${lang}/sidebar/${filename}`;
            return path;
        },
        // 预加载所有侧边栏图标
        preloadSidebarImages() {
            const imagesToLoad = [
                'consult-ic.png',
                'tel-ic.png',
                'down-ic.png',
                'add-ic.png',
                'official-account.png'
            ];

            // 如果是葡语或西语版本，添加小红书二维码；否则添加视频号二维码
            if (this.currentLang === 'pt' || this.currentLang === 'es') {
                imagesToLoad.push('xiaohongshu.png');
            } else {
                imagesToLoad.push('video-account.png');
            }

            if (typeof window !== 'undefined') {
                imagesToLoad.forEach(filename => {
                    const img = new Image();
                    img.onload = () => {
                        this.loadedImages[filename] = true;
                    };
                    // 如果是葡语或西语版本的小红书，使用特殊路径
                    if ((this.currentLang === 'pt' || this.currentLang === 'es') && filename === 'xiaohongshu.png') {
                        img.src = this.xiaohongshuQrCode;
                    } else {
                        img.src = this.getSidebarImagePath(filename);
                    }
                });
            }
        },
        // 图片加载完成处理
        onImageLoaded(filename) {
            if (this.loadedImages.hasOwnProperty(filename)) {
                this.loadedImages[filename] = true;
            }
        },
        handleScroll() {
            this.scrollY = window.scrollY;
            this.showBackTop = this.scrollY > 300;
        },
        handleResize() {
            this.windowHeight = window.innerHeight;
        },
        scrollToTop() {
            const scrollDuration = 500;
            const scrollStep = -window.scrollY / (scrollDuration / 15);

            const scrollInterval = setInterval(() => {
                if (window.scrollY !== 0) {
                    window.scrollBy(0, scrollStep);
                } else {
                    clearInterval(scrollInterval);
                }
            }, 15);
        }
    }
}
</script>

<style scoped lang="scss">
/* 保留原始样式用于active状态 */
.sidebar-content.active {
    opacity: 1 !important;
    visibility: visible !important;
    transform: translateX(0) !important;
}

.fixed-sidebar.active .back-top {
    opacity: 1;
    visibility: visible;
}

/* 移动端适配样式 */
@media (max-width: 767px) {
    .fixed-sidebar {
        right: 5px !important;
    }

    .sldebar-section {
        padding: 6px !important;
    }

    .sidebar-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px !important;
        height: 32px !important;
        text-align: center;
    }

    .sidebar-icon svg {
        width: 24px !important;
        height: 24px !important;
    }

    .sidebar-item {
        margin-bottom: 12px !important;
        font-size: 10px !important;
    }

    .sidebar-content {
        right: 50px !important;
        padding: 8px !important;
        max-width: 200px !important;
    }

    .qrcode-container {
        gap: 5px !important;
    }

    .qrcode-item img {
        width: 80px !important;
        height: 80px !important;
    }

    .qrcode-placeholder {
        width: 80px !important;
        height: 80px !important;
    }

    .followus-content {
        width: 180px !important;
    }

    .tel-content {
        min-width: 120px !important;
        height: 70px !important;
    }
}

/* 超小屏幕适配 */
@media (max-width: 375px) {
    .sidebar-icon {
        width: 28px !important;
        height: 28px !important;
    }

    .sidebar-icon svg {
        width: 20px !important;
        height: 20px !important;
    }

    .sidebar-item {
        margin-bottom: 10px !important;
        font-size: 9px !important;
    }
}

.sidebar-item.back-top {
    display: none;
}

.sidebar-item.back-top.show {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 5px;
    padding: 5px 0 10px 0;
    cursor: pointer;
    font-size: 12px;
    background-color: #fff;
    border-radius: 16px;
    border: 1px solid #ededed;
}
</style>
